<template>
    <div>
        <div class="lg:flex lg:justify-around lg:space-x-4">
            <a class="flex shadow-sm rounded-md lg:w-1/4" href="/admin/statistics">
                <div
                    class="flex-shrink-0 flex items-center justify-center w-16 bg-office-secondary text-white text-sm font-medium rounded-l-md">
                    <i class="fa fa-users"></i>
                </div>
                <div
                    class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                    <div class="flex-1 px-4 py-2 text-sm truncate">
                        <span class="hover:text-gray-600 leading-6 font-medium text-gray-900">User</span>
                        <p class="text-gray-500"> {{ sum }} </p>
                    </div>
                </div>
            </a>
            <a class="flex shadow-sm rounded-md lg:w-1/4" href="/admin/statistics">
                <div
                    class="flex-shrink-0 flex items-center justify-center w-16 bg-office-secondary text-white text-sm font-medium rounded-l-md">
                    <i class="fa fa-desktop"></i>
                </div>
                <div
                    class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                    <div class="flex-1 px-4 py-2 text-sm truncate">
                        <span class=" hover:text-gray-600 leading-6 font-medium text-gray-900">Arbeitsplätze</span>
                        <p class="text-gray-500"> {{ desks }} </p>
                    </div>
                </div>
            </a>
            <a class="flex shadow-sm rounded-md lg:w-1/4" href="/admin/statistics">
                <div
                    class="flex-shrink-0 flex items-center justify-center w-16 bg-office-secondary text-white text-sm font-medium rounded-l-md">
                    <i class="fa fa-users"></i>
                </div>
                <div
                    class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                    <div class="flex-1 px-4 py-2 text-sm truncate">
                        <span class=" hover:text-gray-600 leading-6 font-medium text-gray-900">Konferenzräume</span>
                        <p class="text-gray-500"> {{ conferenceRooms }} </p>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>

export default {
    name: "InfoStatistics",
    components: {},
    inject: ['group'],
    props: ['tenants', 'desks','free', 'owners', 'rooms', 'conferenceRooms'],

    computed: {
        sum() {
            return this.tenants + this.owners;
        },
    },
}
</script>

<style>

</style>